import { render, staticRenderFns } from "./Cooperative.vue?vue&type=template&id=02412b68&scoped=true&"
import script from "./Cooperative.vue?vue&type=script&lang=js&"
export * from "./Cooperative.vue?vue&type=script&lang=js&"
import style0 from "./Cooperative.vue?vue&type=style&index=0&id=02412b68&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "02412b68",
  null
  
)

export default component.exports